import React from 'react';
import './ui.css';

export const StatCard: React.FC<{
  value: React.ReactNode; label: string; tone?: 'default' | 'success' | 'error' | 'muted';
}> = ({ value, label, tone = 'default' }) => (
  <div className={`ui-card ui-stat${tone !== 'default' ? ` ui-stat--${tone}` : ''}`}>
    <div className="ui-stat__value">{value}</div>
    <div className="ui-stat__label">{label}</div>
  </div>
);
